import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import { decryptVendorParams } from "../utils/vendorCrypto";

import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { Link } from "react-router-dom";
import companyLogo from "../assets/images/logo-new.png";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  Close as CloseIcon,
  Inbox as InboxIcon,
  Dashboard as DashboardIcon,
  BookOnline as BookOnlinedIcon,
  TableRows as TableRowsdIcon,
  ConfirmationNumberTwoTone as ConfirmationNumberTwoToneIcon,
  FormatListNumberedTwoTone as FormatListNumberedTwoToneIcon,
  CategoryTwoTone as CategoryTwoToneIcon,
  AcUnitTwoTone as AcUnitTwoToneIcon,
  SettingsTwoTone as SettingsTwoToneIcon,
  ContentPasteGo as ContentPasteGoIcon,
  AccessTime as AccessTimeIcon,
  HelpOutlineOutlined,
  Person2,
} from "@mui/icons-material";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import Collapse from "@mui/material/Collapse";

import UserManual from "../assets/pdf/ramcides-user-manual.pdf";
import AdminManual from "../assets/pdf/ramcides-admin-manual.pdf";

function Layout(props) {
  const handleLogout = () => {
    localStorage.removeItem("user");
  };

  const [menuOpenedFlag, setMenuOpenedFlag] = useState(false);
  const showMenuIcon = () => {
    setMenuOpenedFlag(!menuOpenedFlag);
  };
  const [open, setOpen] = React.useState(false);
  const activeUrl = window.location.pathname;
  const [sideMenus, setSideMenus] = useState([]);
  const useRefApp = useRef(false);
  const userData = JSON.parse(localStorage.getItem("user")) || {};
  useEffect(() => {
    if (useRefApp.current === false) {
      if (
        activeUrl === "/agent/user/list" ||
        activeUrl === "/agent/user/import" ||
        activeUrl === "/agent/user/add"
      ) {
        setOpen(true);
      }

      console.log(userData.role);
      if (userData.role === "agent" || userData.role === "Admin") {
        setSideMenus([
          {
            title: "Dashboard",
            url: "/agent/dashboard",
            icon: <DashboardIcon className="color--white" />,
          },
          {
            title: "New Ticket",
            url: "/agent/new",
            icon: <ConfirmationNumberTwoToneIcon className="color--white" />,
          },
          {
            title: "Tickets",
            url: "/agent/list",
            icon: <ConfirmationNumberTwoToneIcon className="color--white" />,
          },
          {
            title: "To Do",
            url: "/agent/todo",
            icon: <FormatListNumberedTwoToneIcon className="color--white" />,
          },
          {
            title: "Issue Type",
            url: "/agent/settings",
            icon: <CategoryTwoToneIcon className="color--white" />,
          },
          {
            title: "Configuration",
            url: "/agent/other-settings",
            icon: <AcUnitTwoToneIcon className="color--white" />,
          },
          {
            title: "Email Configuration",
            url: "/agent/email-configuration",
            icon: <SettingsTwoToneIcon className="color--white" />,
          },
          {
            title: "Assets",
            url: "/agent/assets",
            icon: <ContentPasteGoIcon className="color--white" />,
          },
          // {
          //   title: "Report",
          //   url: "/agent/report",
          //   icon: <SettingsTwoToneIcon className="color--white" />,
          // },
          {
            title: "SLA",
            url: "/agent/sla",
            icon: <AccessTimeIcon className="color--white" />,
          },
          {
            title: "Vendor",
            url: "/agent/vendor",
            icon: <SettingsTwoToneIcon className="color--white" />,
          },

          // {
          //   title: "Report",
          //   url: "/agent/report",
          //   icon: <ContentPasteGoIcon className="color--white" />,
          // },
        ]);
      } else if (userData.role === "user") {
        setSideMenus([
          // {
          //   title: "Dashboard",
          //   url: "/user/ticket/dashboard",
          //   icon: <DashboardIcon className="color--white" />,
          // },
          {
            title: "New Ticket",
            url: "/user/ticket/new",
            icon: <BookOnlinedIcon className="color--white" />,
          },
          {
            title: "Tickets",
            url: "/user/ticket/list",
            icon: <ConfirmationNumberTwoToneIcon className="color--white" />,
          },
        ]);
      }
      console.table(sideMenus);
    }
    return () => {
      useRefApp.current = true;
    };
  }, []);

  const searchParams = new URL(window.location.href).searchParams;
  const vToken = searchParams.get("vToken");
  const decrypted = decryptVendorParams(vToken);
  const isVendorView = (decrypted && decrypted.vId && decrypted.vEmail) || 
                       ((searchParams.get("vId") || searchParams.get("vld") || searchParams.get("vid")) && (searchParams.get("vEmail") || searchParams.get("vemail")));

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <Box>
      <Grid container>
        {!isVendorView && (
          <Grid className={`sidenav ${menuOpenedFlag ? `open` : ``}`}>
            <Grid textAlign={`right`}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={showMenuIcon}
                color="inherit"
                className="btn"
              >
                <CloseIcon sx={{ color: `white` }} />
              </IconButton>
            </Grid>
            <List>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    px: 2.5,
                  }}
                >
                  <img
                    src={companyLogo}
                    alt="Ramcides"
                    width={`70px`}
                    height={`70px`}
                  />
                  <Typography className={`company-name`}>Ramcides</Typography>
                </ListItemButton>
                {sideMenus.map((row, id) => (
                  <Link
                    to={row.url}
                    key={id}
                    className={`sidemenu--item ${activeUrl === "" + row.url ? `active` : ``
                      }`}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          justifyContent: "center",
                        }}
                      >
                        {row.icon}
                      </ListItemIcon>
                      <ListItemText
                        className="color--white"
                        primary={row.title}
                      />
                    </ListItemButton>
                  </Link>
                ))}

                {userData.role !== "user" ? (
                  <>
                    <ListItemButton onClick={handleClick}>
                      <ListItemIcon>
                        <Person2 className="color--white" />
                      </ListItemIcon>
                      <ListItemText primary="Users" className="color--white" />
                      {open ? (
                        <ExpandLess className="color--white" />
                      ) : (
                        <ExpandMore className="color--white" />
                      )}
                    </ListItemButton>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                      <Link
                        to={"/agent/user/import"}
                        className={`sidemenu--item ${activeUrl === "" + "/agent/user/import" ? `active` : ``
                          }`}
                      >
                        <ListItemButton sx={{ pl: 4 }}>
                          {/* <ListItemIcon>
                      <StarBorder className="color--white" />
                    </ListItemIcon> */}
                          <ListItemText
                            primary="Import User"
                            className="color--white"
                          />
                        </ListItemButton>
                      </Link>
                      <Link
                        to={"/agent/user/list"}
                        className={`sidemenu--item ${activeUrl === "" + "/agent/user/list" ? `active` : ``
                          }`}
                      >
                        <ListItemButton sx={{ pl: 4 }}>
                          {/* <ListItemIcon>
                      <StarBorder className="color--white" />
                    </ListItemIcon> */}
                          <ListItemText
                            primary="All Users"
                            className="color--white"
                          />
                        </ListItemButton>
                      </Link>
                      {userData.role === "Admin" ? (
                        <Link
                          to={"/agent/user/add"}
                          className={`sidemenu--item ${activeUrl === "" + "/agent/user/add" ? `active` : ``
                            }`}
                        >
                          <ListItemButton sx={{ pl: 4 }}>
                            {/* <ListItemIcon>
                        <StarBorder className="color--white" />
                      </ListItemIcon> */}
                            <ListItemText
                              primary="Add Users"
                              className="color--white"
                            />
                          </ListItemButton>
                        </Link>
                      ) : (
                        <></>
                      )}
                    </Collapse>
                  </>
                ) : (
                  <></>
                )}

                <a
                  href={userData.role === "user" ? UserManual : AdminManual}
                  className={`sidemenu--item`}
                  target="_blank"
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        justifyContent: "center",
                      }}
                    >
                      <HelpOutlineOutlined className="color--white" />
                    </ListItemIcon>
                    <ListItemText className="color--white" primary="Help" />
                  </ListItemButton>
                </a>

                <Link onClick={handleLogout} className={`sidemenu--item`}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        justifyContent: "center",
                      }}
                    >
                      <LogoutIcon className="color--white" />
                    </ListItemIcon>
                    <ListItemText className="color--white" primary="Logout" />
                  </ListItemButton>
                </Link>
              </ListItem>
            </List>
          </Grid>
        )}
        <Grid className="topnav" sx={{ pb: 10, ...(isVendorView && { width: "100%", marginLeft: 0 }) }}>
          {!isVendorView && (
            <>
              <Header menuAction={showMenuIcon} menuOpenedFlag={menuOpenedFlag} isVendorView={isVendorView} />
              <div className="empty-space-30"></div>
              <Typography sx={{ p: 1 }} className={`page-title`}>
                {sideMenus.map((row, id) =>
                  activeUrl === "" + row.url ? row.title : ``
                )}

                {activeUrl === `/agent/user/add`
                  ? `Add Admin`
                  : activeUrl === `/agent/user/list`
                    ? `All Users`
                    : activeUrl === `/agent/user/import`
                      ? `Import User`
                      : ``}
              </Typography>
              <div className="empty-space-30"></div>
            </>
          )}
          {props.children}
        </Grid>
      </Grid>
      <footer className="copyright">
        <Typography>
          Designed By{" "}
          <a href="https://www.imaginetventures.com/" target="_blank">
            ImagiNET Ventures
          </a>
        </Typography>
      </footer>
    </Box>
  );
}

export default Layout;
